import { Redirect } from "react-router-dom";

import { FeatureFlags, useFeatureEnabled } from "~/v2/helpers/featureFlags";
import { Path } from "~/v2/path";
import { useWhitelistAddressController } from "./WhitelistAddress.controller";
import { WhitelistAddressPresentation } from "./WhitelistAddress.pres";

const WhitelistAddressInner = () => {
  const props = useWhitelistAddressController();
  return <WhitelistAddressPresentation {...props} />;
};

export const WhitelistAddressConnector = () => {
  const isTRCEnabled = useFeatureEnabled(FeatureFlags.CRYPTO_TRC);
  if (!isTRCEnabled) {
    return <Redirect to={Path.ROUTE_CRYPTO_TRANSFERS} />;
  }

  return <WhitelistAddressInner />;
};
